import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-3",
  style: {"font-size":"16px"}
}
const _hoisted_7 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Tra cứu", -1)
const _hoisted_12 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-9",
  style: {"font-size":"16px"}
}
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Họ và tên", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Ngày sinh", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Số điện thoại", -1)
const _hoisted_20 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_23 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_24 = { style: {"margin":"auto","width":"30%"} }
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col-3 p-md-3" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_30 = { class: "p-fluid" }
const _hoisted_31 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_32 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_33 = { style: {"width":"40%","margin":"auto"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  id: "scroll-container"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "scroll-text",
    style: {"align-items":"center","width":"150%"}
  }, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("label", { style: {"color":"#3e9cba","font-size":"20px"} }, " BỆNH VIỆN Y HỌC CỔ TRUYỀN THÀNH PHỐ ĐÀ NẴNG ")
  ])
], -1)
const _hoisted_35 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_36 = { id: "loading" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Hệ thống đang xử lý, vui lòng chờ trong giây lát ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_camera = _resolveComponent("camera")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Panel, {
          header: "Hệ thống đăng ký sinh trắc học bệnh nhân",
          style: {"padding-bottom":"-10px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Panel, { header: "Tra cứu bệnh nhân" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(_component_InputText, {
                              id: "name",
                              type: "text",
                              modelValue: $setup.maYTe,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maYTe) = $event)),
                              style: {"text-align":"center","font-size":"16px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createVNode(_component_Button, {
                              label: "Tìm",
                              icon: "pi pi-plus-circle",
                              iconPos: "left",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadListCls())),
                              style: {"font-size":"16px"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    ($setup.thongTinBN.tenbenhnhan != null)
                      ? (_openBlock(), _createBlock(_component_Panel, {
                          key: 0,
                          header: "Thông tin bệnh nhân"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createVNode(_component_InputText, {
                                  id: "hoVaTen",
                                  type: "text",
                                  modelValue: $setup.thongTinBN.tenbenhnhan,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.thongTinBN.tenbenhnhan) = $event)),
                                  style: {"text-align":"center","font-size":"16px"},
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createVNode(_component_InputText, {
                                  id: "ngaySinh",
                                  modelValue: $setup.ngaySinh,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.ngaySinh) = $event)),
                                  type: "text",
                                  style: {"text-align":"center","font-size":"16px"},
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createVNode(_component_InputText, {
                                  id: "dt",
                                  type: "text",
                                  modelValue: $setup.thongTinBN.sodienthoai,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.thongTinBN.sodienthoai) = $event)),
                                  style: {"text-align":"center","font-size":"16px"},
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.thongTinBN.tenbenhnhan != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_camera, {
                                  resolution: { width: 480, height: 270 },
                                  facingMode: { exact: _ctx.user },
                                  ref: "camera",
                                  onError: $setup.error,
                                  autoplay: ""
                                }, null, 8, ["facingMode", "onError"]),
                                _createVNode(_component_Button, {
                                  onClick: $setup.snapshot,
                                  label: "Chụp hình",
                                  icon: "pi pi-camera",
                                  style: {"font-weight":"bold"},
                                  severity: "success",
                                  raised: ""
                                }, null, 8, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listUrl, (x) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_Card, { style: {"width":"10rem","overflow":"hidden"} }, {
                                          header: _withCtx(() => [
                                            _createElementVNode("img", {
                                              id: "image",
                                              src: x,
                                              style: {"width":"10rem"}
                                            }, null, 8, _hoisted_28)
                                          ]),
                                          footer: _withCtx(() => [
                                            _createVNode(_component_Button, {
                                              label: "Xóa",
                                              class: "w-full",
                                              onClick: ($event: any) => ($setup.deleteImage(x)),
                                              icon: "pi pi-trash",
                                              severity: "danger"
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  }), 256))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  ($setup.listBlob?.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                          _createVNode(_component_Button, {
                                            label: "Đăng hình",
                                            class: "w-full",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.uploadImage())),
                                            icon: "pi pi-upload",
                                            severity: "info"
                                          })
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_Dialog, {
          header: "Đăng hình lên ",
          visible: $setup.loadingBar,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($setup.loadingBar) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                style: {"height":".3em"}
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_ConfirmDialog)
      ])
    ])
  ]))
}